const planetData = [
{
    name: "The Sun",
    type: "Star",
    diameter: "1.3927 million km",
    description: "The Sun is the star at the center of the Solar System. It is a nearly perfect sphere of hot plasma, heated to incandescence by nuclear fusion reactions in its core, radiating the energy mainly as light and infrared radiation. It is by far the most important source of energy for life on Earth."
},
    
{
    name: "Mercury",
    type: "Planet",
    diameter: "4875.2 km",
    description: "Mercury is the closest planet to the sun. It rotates slowly — about twice for every three orbits it completes. Its cratered surface can experience temperatures upwards of 800 degrees Fahrenheit (426.7 degrees Celsius) because of its proximity to the sun. "
},

{
    name: "Venus",
    type: "Planet",
    diameter: "12103.6 km",
    description: "The second planet from the sun, Venus is slightly smaller than Earth. Because of its relative proximity to Earth, it is the largest planet seen in the night sky. The cratered surface is hot with surface temperatures around 900 F (482 C), the product of a runaway greenhouse effect. "
},

{
    name: "Earth",
    type: "Planet",
    diameter: "12756.2 km",
    description: "Earth, the third planet from the sun and the largest terrestrial planet, is the only planet known to host living beings and the only one known to have liquid water on its surface."
},

{
    name: "Mars",
    type: "Planet",
    diameter: "12756.2 km",
    description: "Stargazers from antiquity have called Mars, the fourth planet from the sun, Mars, the Red Planet. The red color of the surface comes from iron oxide or rust in the soil. The topography is characterized by large volcanoes and deep valleys, and Mars experiences frequent planet-wide wind storms."
},

{
    name: "Jupiter",
    type: "Planet",
    diameter: "139822 km",
    description: "Further from the sun, past a ring of asteroids, lies the largest planet in our solar system — Jupiter — the first of the gas giant planets. Its characteristic colored cloud patterns are caused by enormous, swirling storms in its atmosphere, which consists of primarily of hydrogen, helium, methane ammonia and water ice."
},

{
    name: "Saturn",
    type: "Planet",
    diameter: "116464 km",
    description: "Saturn, the sixth planet from the sun, is also a gas giant, and it's most impressive feature as seen from afar is an extensive and complex ring system. The rings orbit the planet in a thin band about a mile thick. The radius of Saturn is about 9.5 times that of Earth, and instead of one paltry moon, it boasts 62. "
},

{
    name: "Neptune",
    type: "Planet",
    diameter: "49244 km",
    description: "The blue planet Neptune is the farthest one from the sun and, like Uranus, is a very cold place. Its surface temperature is a chilly -353 F (-214 C). Because of its distance from the sun and its large orbit, one year on Neptune is 165 Earth years. The atmosphere is mostly methane, which gives the planet its blue color. "
},

{
    name: "Uranus",
    type: "Planet",
    diameter: "50724 km",
    description: "While most planets spin on their axis with a slight tilt, the ice giant Uranus spins on an axis parallel to its orbit. With a diameter of 31,518 miles (50,723 kilometers), this cold planet is four times the size of Earth and is made of a large atmosphere of methane with a dense core of frozen methane."
},

{
    name: "Pluto",
    type: "Dwarf Planet",
    diameter: "2376.4 km",
    description: "Pluto is the most well known of the dwarf planets. Since its discovery in 1930 and until 2006, it had been classified as the ninth planet from the sun. Pluto's orbit was so erratic, however, that at times it was closer to the sun than the eighth planet, Neptune. In 2006, with the discovery of several other rocky bodies similar in size or larger than Pluto, the IAU decided to re-classify Pluto as a dwarf planet."
},

{
    name: "Makemake",
    type: "Dwarf Planet",
    diameter: "1430 km",
    description: "Makemake is about 890 miles (1,430 km) wide, making it about two-thirds the diameter of Pluto. Light from this distant star appeared and disappeared quickly as Makemake passed in front of it. This suggests there was no significant atmosphere around it to smear out the star's light."
},

{
    name: "Haumea",
    type: "Dwarf Planet",
    diameter: "1632 km",
    description: "Haumea is unique because of its ellipsoid shape, only just meeting the hydrostatic equilibrium criteria for dwarf planet status. The elongated shape of the dwarf planet is due to its rapid rotational spin, not a lack of mass, which is about one-third that of Pluto."
},

{
    name: "Eris",
    type: "Dwarf Planet",
    diameter: "2362 km",
    description: "When it was first discovered, Eris was thought to be the largest of the dwarf planets, with a mass 27 percent larger than that of Pluto and a diameter of approximately 1,400 to 1,500 miles (2,300 to 2,400 km)."
},

{
    name: "Ceres",
    type: "Dwarf Planet",
    diameter: "848.4 km",
    description: "Ceres is the earliest known and smallest of the current category of dwarf planets. In fact, Ceres is so small that it is classified as both a dwarf planet and an asteroid, and is often named in scientific literature as one of the largest asteroids in the solar system."
},

{
    name: "The Moon",
    type: "Moon",
    diameter: "3474.2 km",
    description: "The Moon is an astronomical body orbiting Earth and is the planet's only natural satellite. It is the fifth-largest satellite in the Solar System, and by far the largest among planetary satellites relative to the size of the planet that it orbits. "
},

{
    name: "Loading",
    type: " ",
    diameter: "one sphere-shaped loading bar",
    description: "Fetching data from the IMCCE. This will take a couple of seconds"
}

];

export default planetData;
